import { createClient } from '@supabase/supabase-js'

/**
 * Supabase-klienten.
 *
 * Bara anon-nyckeln finns här. Den är publik by design — allt skydd ligger i
 * RLS-policyerna, inte i att nyckeln är hemlig. service_role får aldrig
 * komma i närheten av frontend; den bor som Worker-secret.
 */

const url = import.meta.env.VITE_SUPABASE_URL
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!url || !anonKey) {
  throw new Error(
    'VITE_SUPABASE_URL och VITE_SUPABASE_ANON_KEY måste vara satta. Se frontend/.env.example.',
  )
}

export const supabase = createClient(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
})
